import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as SearchSvg } from './assets/search.svg';

const SearchIcon = React.forwardRef((args, ref) => <SvgIcon component={SearchSvg} ref={ref} {...args} />);

export default SearchIcon;
